const host = "http://t.emc.bitiot.com.cn/v1";
// const host = "http://192.168.20.175:9120/v1";

export default host